import { defineAsyncComponent } from 'vue'
import type { RoundTypeHandler } from '../RoundTypeHandler'

/**
 * Multiple Choice Round Type Plugin
 * Provides self-contained MC round functionality for moderators and teams
 */
export const multipleChoiceHandler: RoundTypeHandler = {
  type: 'MULTIPLE_CHOICE',
  label: 'Multiple Choice',
  icon: 'mdi-format-list-checkbox',
  description: 'Single or multiple answer selection with auto-validation',

  // Lazy-loaded components
  ModeratorView: defineAsyncComponent(
    () => import('./MCModeratorView.vue')
  ),
  TeamView: defineAsyncComponent(
    () => import('./MCTeamView.vue')
  ),

  capabilities: {
    timer: true,
    buzzer: false, // MC rounds typically don't use buzzers
    submissions: true,
    autoValidation: true
  },

  parseConfig(configJson: string) {
    try {
      return JSON.parse(configJson)
    } catch (error) {
      console.error('Failed to parse MC config:', error)
      return null
    }
  },

  validateConfig(config: any): true | string {
    if (!config) return 'Configuration is required'
    if (!config.question || typeof config.question !== 'string') {
      return 'Question text is required'
    }
    if (!Array.isArray(config.options) || config.options.length < 2) {
      return 'At least 2 options are required'
    }

    const hasCorrect = config.options.some((opt: any) => opt.correct === true)
    if (!hasCorrect) {
      return 'At least one option must be marked as correct'
    }

    return true
  }
}

// Export for direct import
export { useMCRound } from './useMCRound'
